export default __webpack_public_path__ + "static/media/home_white.875731cf.svg";